"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["onClick", "disabled"];
const _hoisted_2 = {
    key: 1,
    src: "/svg/test-answer-tick.svg",
    alt: "Tick",
    class: "w-8 h-8"
};
const _hoisted_3 = {
    key: 2,
    src: "/svg/test-answer-cross.svg",
    alt: "Cross",
    class: "w-8 h-8"
};
const vue_3 = require("vue");
const ProficiencyTest_1 = require("../../stores/ProficiencyTest");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AnswerButton',
    props: {
        answer: {
            type: Object,
            required: true,
        },
        answered: {
            type: Boolean,
            required: true,
        },
        selected: {
            type: Boolean,
            required: true,
        },
        type: {
            type: String,
            default: 'inline',
        },
    },
    emits: ['click'],
    setup(__props, { emit }) {
        const props = __props;
        const store = (0, ProficiencyTest_1.useProficiencyTestStore)();
        function onClick() {
            emit('click');
        }
        const buttonClass = (0, vue_3.computed)(() => {
            const output = [props.type === 'corner' ? 'rounded-tl-3xl rounded-br-3xl' : 'rounded-r'];
            if (!props.selected) {
                return ['bg-beige-400', ...output];
            }
            if (!store.answerSubmitted) {
                return ['bg-mutedpurple-800', ...output];
            }
            if (props.answer.correct) {
                return ['bg-green-200', ...output];
            }
            return ['bg-red-500', ...output];
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                type: "button",
                onClick: (0, vue_2.withModifiers)(onClick, ["prevent"]),
                class: (0, vue_2.normalizeClass)(["w-14 flex-shrink-0 flex justify-center items-center", (0, vue_2.unref)(buttonClass)]),
                disabled: (0, vue_2.unref)(store).answerSubmitted
            }, [
                (!(0, vue_2.unref)(store).answerSubmitted)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                        key: 0,
                        class: (0, vue_2.normalizeClass)(["w-[10px] h-[10px] rounded-full", __props.selected ? 'bg-beige-100' : 'bg-mutedpurple-800'])
                    }, null, 2))
                    : (__props.answer.correct)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("img", _hoisted_2))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("img", _hoisted_3))
            ], 10, _hoisted_1));
        };
    }
});
